import PersonalizedCategory from './PersonalizedCategory.component';

export default PersonalizedCategory;